import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class HubspotService {
  private loaded = false;
  private scriptId = 'hs-script-loader';

  isLoaded(): boolean {
    return this.loaded || !!document.getElementById(this.scriptId);
  }

  init(): void {
    if (!environment.production) return;
    if (this.isLoaded()) {
      this.loaded = true;
      return;
    }

    try {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.id = this.scriptId;
      s.async = true;
      s.defer = true;
      s.src = 'https://js-eu1.hs-scripts.com/146835445.js';
      s.onload = () => {
        this.loaded = true;
        try {
          const path = window.location.pathname + window.location.search;
          try {
            window.history.replaceState({}, '', path);
          } catch (err) {
            console.warn('HubSpot history.replaceState failed', err);
          }
          window._hsq = window._hsq || [];
          window._hsq.push(['setPath', path]);
          window._hsq.push(['trackPageView']);
        } catch (err) {
          console.warn('HubSpot setPath/trackPageView failed on load', err);
        }
      };
      s.onerror = err => console.warn('Failed to load HubSpot script', err);
      document.head.appendChild(s);
    } catch (err) {
      console.warn('HubSpot init failed', err);
    }
  }

  removeWidget(): void {
    try {
      (window as any).HubSpotConversations?.widget?.remove?.();
    } catch (err) {
      console.warn('HubSpot removeWidget failed', err);
    }
  }

  resetAndReloadWidget(): void {
    try {
      const fn = (window as any).HubSpotConversations?.resetAndReloadWidget;
      if (typeof fn === 'function') {
        fn();
        return;
      }
    } catch (err) {
      console.warn('HubSpot resetAndReloadWidget failed', err);
    }
    this.reloadScript();
  }

  private reloadScript(): void {
    try {
      const el = document.getElementById(this.scriptId);
      if (el) el.remove();
      this.loaded = false;
      this.init();
    } catch (err) {
      console.warn('HubSpot reloadScript failed', err);
    }
  }
}
